<template>
	<ul class="stepBtnsRight">
		<li>
			<button :disabled="disabled" class="jmiBtn btnLg green" @click="$emit('save')">
				{{ saveLabel }}
			</button>
		</li>
		<li>
			<button class="jmiBtn btnLg red" @click="$emit('close')">Close</button>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		disabled: Boolean,
		saveLabel: {
			type: String,
			default: 'Save'
		}
	},
	emits: ['save', 'close']
}
</script>
